// extracted by mini-css-extract-plugin
export default {"warning":"MessageAlert_warning__5uHWE","error":"MessageAlert_error__iJJK1"};